import icons from "assets/icons"
import {getPermission, userInfo} from "./Auth"
import moment from "moment"

export const themeColors = {
    primary:'#2251F8',
    primaryLight:'#D6DFFF',
    success:'#00A15D',
    successLight:'#DCEEE6',
    danger: '#FC2E53',
    dangerLight:'#FFD8D6',
    warning:'#FFD34B',
    warningLight:'#ffedb6',
    defaultFont:'#3C3C3C',
    lightGray200:'#EEEEEE',
}

export const chartTypes = {
    bar:'BAR',
    pie:'PIE'
}
export const isAdmin = userInfo ? userInfo['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']?.includes('Administrator') : false
export const isAM = userInfo ? userInfo['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']?.includes('AccountManager') : false
export const isPM = userInfo ? userInfo['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']?.includes('ProjectManager') : false
export const isTL = userInfo ? userInfo['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']?.includes('TeamLead') : false
export const isHr = userInfo ? userInfo['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']?.includes('HumanResources') : false
export const isAc = userInfo ? userInfo['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']?.includes('Accounting') : false
export const menu = [
    {icon : <icons.user/>, name:"Portal Kullanıcıları", path: '/users',disabled:!isAdmin},
    {icon : <icons.dashboard/>, name:"Projeler", path: '/projects',disabled:!getPermission('Project.read')},
    {icon : <icons.user/>, name:"Çalışanlar", path: '/developers', disabled:(!isTL && !isAdmin && !isHr && !isAc)},
    { icon: <icons.dashboardCustomize />, name: 'CRM', disabled: !getPermission('CrmManagement.read'), subMenu:[
        {icon : <icons.chart/>, name:"Kurumsal Müşteriler",  path: '/crm-management', disabled: !getPermission('CrmManagement.read')},
        { icon: <icons.dashboardCustomize />, name: 'Leads', path: '/lead-management', disabled: !getPermission('LeadManagement.read') },
        {icon : <icons.chart/>, name:"Rehber", path: '/crm-directory', disabled: !getPermission('CrmManagement.read')},
        {icon : <icons.chart/>, name:"Hatırlatıcılar", path: '/crm-reminders', disabled: !getPermission('CrmManagement.read')},
   ] },
    {icon : <icons.dashboard/>, name:"İzin Yönetimi", path: '/leave',disabled:!getPermission('DeveloperLeave.read')},
    {icon : <icons.user/>, name:"Planlama", disabled: (!getPermission('WeeklyPlan.read') && !getPermission('MasterPlan.read')), subMenu:[
        {icon : <icons.chart/>, name:"Haftalık Planlar", path: '/weekly-plan', disabled: !getPermission('WeeklyPlan.read')},
        {icon : <icons.chart/>, name:"Çalışanlar Master Plan", path: '/master-plan', disabled: !getPermission('MasterPlan.read')},
   ]},
    {icon : <icons.user/>, name:"Raporlar", disabled: (!isTL && !isAdmin && !isAM && !isPM && !isHr && !isAc), subMenu:[
    {icon : <icons.chart/>, name:"Fatura Raporları", path: '/billing-statement', disabled:!getPermission('Invoice.read')},
    {icon : <icons.chart/>, name:"Sla Raporu", path: '/sla-report', disabled:(!isAM && !isPM && !isAdmin)},
    {icon : <icons.chart/>, name:"Leasing Raporu", path: '/leasing-report', disabled:(!isAM && !isPM && !isAdmin)},
    {icon : <icons.chart/>, name:"Rate Raporu", path: '/rate-report', disabled:(!isAM && !isPM && !isAdmin)},
    {icon : <icons.report/>, name:"Fatura Kesilebilir Raporu", path: '/invoice-report', disabled:(!isAdmin)},
    {icon : <icons.report2/>, name:"Ödeme Raporları", path: '/billing-report', disabled:(!isAdmin)},
    {icon : <icons.report2/>, name:"Efor Analiz Raporu", path: '/effort-analysis-report', disabled:(!isAdmin && !isTL && !isPM )},
    {icon : <icons.report2/>, name:"Proje Detay Raporu", path: '/project-report', disabled:(!isAdmin && !isTL && !isPM )},
    {icon : <icons.report2/>, name:"Developer Plan Raporu", path: '/developer-plan-report', disabled:(!isAdmin && !isPM)},
    {icon : <icons.report2/>, name:"PM Plan Raporu", path: '/project-plan-report', disabled:(!isAdmin )},
    {icon : <icons.report2/>, name:"İzin Yükü Raporu", path: '/leaves-report', disabled:(!isAdmin && !isHr && !isAc )},
    {icon : <icons.report2/>, name:"İzin Hareket Raporu", path: '/leave-movements-report', disabled:(!isAdmin && !isHr && !isAc )},
    {icon : <icons.report2/>, name:"Outsource Fatura Raporu", path: '/outsource-invoice-report', disabled:(!isAdmin && !isHr )},
]},

]
export const sourceTypes = {
    TURNKEY:1,
    SLA:2,
    CR:3,
    OUTSOURCE:4,
    LEASING: 5
}
export const projectTypes = [
    {
        type:'Turnkey',
        value: '1'
    },
    {
        type:'Sla',
        value: '2'
    },
    {
        type:'Cr',
        value: '3'
    },
    {
        type:'Outsource',
        value: '4'
    },
    {
        type:'Leasing',
        value: '5'
    }
]
export const reportTypes = [
    {
        type:'Haftalık Statü Raporu',
        value: '1'
    },
    {
        type:'Aylık SLA Raporu',
        value: '2'
    },
]

export const documentTypes = [
    {
        type:'Haftalık Statü Raporu',
        value: '1'
    },
    {
        type:'Aylık Statü Raporu',
        value: '2'
    },
    {
        type:'Analiz Dökümanı',
        value: '3'
    },
    {
        type:'Eğitim Dökümanı',
        value: '4'
    },
    {
        type:'Diğer',
        value: '5'
    },
    {
        type:'Proje Planı',
        value: '6'
    },
    {
        type:'Proje Künyesi',
        value: '7'
    },
]

export const leaveType = [
    {
        type:'Yıllık',
        value: '1'
    },
    {
        type:'Hastalık',
        value: '2'
    },
    {
        type:'Evlilik',
        value: '3'
    },
    {
        type:'Bebek',
        value: '4'
    },
]

export const leaveDayPeriod = [
    {
        type: 'Tam Gün',
        value: 0
    },
    {
        type: 'Öğleden Önce',
        value: 1
    },
    {
        type: 'Öğleden Sonra',
        value: 2
    },
]
export const calculateIzinGun = (startDate, endDate, startPeriod, endPeriod) => {
    const startMoment = moment(startDate)
    const endMoment = moment(endDate)
    const isSameDay = startMoment.isSame(endMoment, 'day')
    let izinTarSay = endMoment.diff(startMoment, 'days') + 1
    if (isSameDay && startPeriod != 0) {
        izinTarSay -= 0.5
    } else if (!isSameDay) {
        if (startPeriod != 0) {
            izinTarSay -= 0.5
        }
        if (endPeriod != 0) {
            izinTarSay -= 0.5
        }
    }
    return izinTarSay || 0
}
export const outsourcePeriod = [
    {
        type: 'Günlük',
        value: 0
    },
    {
        type: 'Aylık',
        value: 1
    }
]

export const leadManagementStatus = {
    new: { value: 0, label: 'Yeni' },
    preparingScope: { value: 1, label: 'Kapsam Hazırlanıyor' },
    waitingEffort: { value: 2, label: 'Efor Bekleniyor' },
    effortGiven: { value: 3, label: 'Efor Verildi - Teklif Hazırlanıyor' },
    offerGiven: { value: 4, label: 'Teklif Verildi' },
    revisionRequested: { value: 5, label: 'Revizyon İstendi - Teklif Hazırlanıyor' },
    approved: { value: 6, label: 'Onaylandı' },
    suspended: { value: 7, label: 'Askıya Alındı' },
    rejected: { value: 8, label: 'Reddedildi' },
}
export const leadManagementStatusList = Object.values(leadManagementStatus)

export const leadManagementDocumentType = {
    scopeDocument: { value: 1, label: 'Kapsam Dokümanı' },
    effortDocument: { value: 2, label: 'Efor Dokümanı' },
    offerDocument: { value: 3, label: 'Teklif Dokümanı' },
    other: { value: 10, label: 'Diğer' },
}
export const leadManagementDocumentTypeList = Object.values(leadManagementDocumentType)

export const leadManagementProjectDurationType = {
    day: { value: 1, label: 'Gün' },
    week: { value: 2, label: 'Hafta' },
    month: { value: 3, label: 'Ay' },
    year: { value: 4, label: 'Yıl' },
}
export const leadManagementProjectDurationTypeList = Object.values(leadManagementProjectDurationType)

export const getAlertClass = (value) => {
    return value == 1 ? 'alert-success' : (value == 3 || value == 5) ? 'alert-warning' : 'alert-info'
}
export const roleIds = {
    accountManager:4,
    projectManager:5,
    developers:[6,7,8,9],
    admin:10
}
export const getResponsible = (roleId) => {
    if(roleId == 'AM') {
        return 'Account Manager'
    } else if(roleId == 'PM') {
        return 'Project Manager'
    }else if(roleId == 'TL') {
        return 'Team Lead'
    } else if(roleIds.developers.includes(roleId)) {
        return 'Developer'
    }
}
export const responsibleRoles =
    [
        { label: 'Account Manager', value: 'AM' },
        { label: 'Project Manager', value: 'PM' },
        { label: 'Team Lead', value: 'TL' },

    ]

export const taskStatu = (task) => {
    switch (task.ticketStatusId) {
        case 1:
            return {className: 'primary',title:'Açık'}
        case 2:
            return {className: 'success',title:'Tamamlandı'}
        case 3:
        return {className: 'warning',title:'Bilgi Gerekli'}
        default:
            return {className: 'primary',title:'Açık'}
    }
}
export const criticalLevel = (task) => {
    switch (task.ticketPriorityId) {
        case 1:
            return {className: 'danger',title:'Kritik Öncelikli'}
        case 2:
            return {className: 'primary',title:'Düşük Öncelikli'}
        default:
            return {className: 'primary',title:'Düşük Öncelikli'}
    }
}
export const slaTypes = [
    {
        label:'M/D', value:'M/D',
    },
    {
        label:'SLA 7/24', value:'SLA 7/24',
    },
    {
        label:'SLA', value:'SLA',
    }
    ,
    {
        label:'Garanti', value:'Garanti',
    }
]
export const currencyTypes = [
    { label: 'TL', value: 'TL', name:'currency' },
    { label: 'USD', value: 'USD', name:'currency' },
    { label: 'EUR', value: 'EUR', name:'currency'  },
    { label: 'GBP', value: 'GBP', name:'currency'  },
];
